// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {orderSetItem, orderAddItem,orderGetItem,orderCreatedUser} from '../../actions/orderActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/order/OrderAddEditForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {list as areaList} from '../../containers/area/AreaListPage';
import {list as userList} from '../../containers/user/ListPage';
import moment from "jalali-moment";
import {list as orderList} from '../../containers/order/OrderListPage';


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.order.getItem,
        createUser: state.order.createdUser,
        userValue: state.app.currentUser,
        areaList : state.area.areaList,
        userList : state.user.list,
        orderList : state.order.orderList,
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: () => {
        dispatch(getItem());
    },
    getAreaList : () => {
        return(dispatch(areaList()));
    },
    createdUser : (val) => {
        return(dispatch(orderCreatedUser(val)));
    },
    getUserList : (val) => {
        return(dispatch(userList(val)));
    },
    getOrderList : (val) => {
        return(dispatch(orderList(val)));
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    handleSubmit: (value)=>{
        dispatch(add(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

// const createdUser = (val) => {
//     return(dispatch(orderCreatedUser(val)));
// }

const add = (values,mode) => {
    let date = values.year+'/'+values.month+'/'+values.day
    let m = moment(date, 'jYYYY-jM-jD');
    let _ = require('lodash');

    let name = null;
    if(values.name)
        name = values.name;

    let family = null;
    if(values.family)
        family = values.family;

    let orderType = null;
    if(values.order_type)
        orderType = values.order_type;

    let product = null;
    if(values.product)
        product = values.product;

    let description = null;
    if(values.description)
        description = values.description;

    let user_ticket_value = null;
    if(values.user_ticket_value)
        user_ticket_value = values.user_ticket_value;

    // let update_user_ticket = false;
    // if(values.update_user_ticket)
    //     update_user_ticket = values.update_user_ticket;

    return (dispatch, getState) => {

        let states = getState()

        var chooseAddress
        let address = null;
        let addressId;
        let tag = '';
        let geo = null;
        let stateId = 0;
        let cityId = 0;
        if(values.address===1){
            if(values.tag){
                tag = values.tag;
            }
            address = values.new_address;
            addressId = null;
            stateId = values.stateId;
            cityId = values.cityId;
        } else {
            if(values.address){
                chooseAddress = _.find(states.user.list.lists[0].addresses, function(obj) {
                    return obj._id === values.address;
                });
            }
            if(values.new_address){
                address=values.new_address
            }else{
                address=chooseAddress.text
            }
            if(values.geo!==undefined){
                geo=values.geo
            }else{
                if(chooseAddress!==undefined){
                    geo=chooseAddress.geo
                } else {
                    geo=null
                }
            }
            if(values.tag){
                tag=values.tag
            }else{
                tag=chooseAddress.tag
            }
            if(values.stateId){
                stateId=values.stateId
            }else{
                stateId=chooseAddress.stateId
            }
            if(values.cityId){
                cityId=values.cityId
            }else{
                cityId=chooseAddress.cityId
            }
            if(chooseAddress!==undefined){
                if(chooseAddress._id){
                    addressId=chooseAddress._id
                }else{
                    addressId=null
                }
            } else {
                addressId=null
            }
        }

        // if(values.new_address) {
        //     if(values.tag)
        //         tag = values.tag;

        //     address = values.new_address;
        //     addressId = null;
        //     stateId = values.stateId;
        //     cityId = values.cityId;
        // }else if(values.address) {
        //     address = chooseAddress.text;
        //     addressId = chooseAddress._id;
        //     tag = chooseAddress.tag;
        //     geo = chooseAddress.geo;
        //     stateId = chooseAddress.stateId;
        //     cityId = chooseAddress.cityId;
        // }

        let fixture;
        let fixFixtures;
        if(values.fixtures) {
            let fixturesList = states.order.getItem.fixtures
            let fixturesValue = values.fixtures
            fixFixtures = fixturesValue.map(function (item, index) {
                fixture = _.find(fixturesList, {_id: item})
                return fixture;

            });
        }
        let mobile = ''
        if(values.mobile)
            mobile = values.mobile
        else if(states.user.list.lists[0].mobile)
            mobile = states.user.list.lists[0].mobile

        var formData = {
            'name'          : name,
            'family'        : family,
            'mobile'        : mobile,
            'phone_number' : values.phone_number,
            'create_user'   : !values.create_user,
            'order'         : {
                isForce:values.isForce,
                'addressId'      : addressId,
                approximate_time : "EXACT_DATE",
                schedule_time    : m._d,
                order_type       : orderType,
                product          : product,
                fixtures         : fixFixtures,
                user_ticket_value      : user_ticket_value,
                // update_user_ticket      : update_user_ticket,
                description      : description,
                'address'   : {
                    geo     : geo,
                    stateId : stateId,
                    cityId  : cityId,
                    text    : address,
                    tag     : tag,
                },
            },
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.post('order/panel/create', formData).then(list => {
            dispatch(orderAddItem(list.data.lists));
            if(list.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                setTimeout(() => dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/order/list'}), 100)
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        })
        .catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

export const getItem = () => {
    return (dispatch, getState) => {
        API_FETCH.get('order/panel/init').then(orderInfo => {
            dispatch(orderGetItem(orderInfo.data.result));
        }).catch(error => {
            console.log(error);
        });
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
